import { NavLink } from 'react-router-dom';
import { McIcon } from '@maersk-global/mds-react-wrapper';

interface AppSidebarProps {
  isOpen: boolean;
}

export const AppSidebar = ({ isOpen }: AppSidebarProps) => {
  return (
    <aside className={`app-sidebar${isOpen ? ' app-sidebar--open' : ''}`} aria-hidden={!isOpen}>
      <nav className="mds-tree-nav" role="navigation" aria-label="main navigation">
        <ul>
          <li>
            <NavLink
              to="/home"
              className={({ isActive }) =>
                isActive ? 'mds-tree-nav__active' : undefined
              }
            >
              <McIcon icon="house" size={20} />
              Home
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/demands"
              className={({ isActive }) =>
                isActive ? 'mds-tree-nav__active' : undefined
              }
            >
              <McIcon icon="clipboard-list-text" size={20} />
              Demands
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/kanban"
              className={({ isActive }) =>
                isActive ? 'mds-tree-nav__active' : undefined
              }
            >
              <McIcon icon="layout-2x2" size={20} />
              Kanban
            </NavLink>
          </li>
        </ul>
      </nav>
    </aside>
  );
};
